import ReactDOMServer from 'react-dom/server';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import L from 'leaflet';
import {
  Marker, Popup, Tooltip,
} from 'react-leaflet';
import { EwsIcon } from '../../../assets/svg/Icon';

// components
import StyledMarker from '../../../components/marker/Marker';

// leaflet
import 'leaflet/dist/leaflet.css';
import '../../../components/map/Style.css';
import EwsColor from '../../../components/color/ews/EwsColor';
import { styles } from '../style';

const useStyles = makeStyles(styles);

export default function EarlyWarningMap(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas } = props;

  function styleMarker(color) {
    return ({
      type: 'ews',
      colorinfo: {
        icon: 'EwsIcon',
        label: 'shapeEws',
        color,
      },
    });
  }

  const eachData = (data, i) => {
    if (data.latitude && data.longitude) {
      // marker position
      const position = [parseFloat(data.latitude), parseFloat(data.longitude)];

      // status colors
      const statusColor = EwsColor(data.status);
      // marker icons
      const styleClass = styleMarker(statusColor.color.statusColor);
      const icon = L.divIcon({
        className: 'styleLevel',
        html: ReactDOMServer.renderToString(<StyledMarker
          category={styleClass.type}
          type={styleClass.colorinfo}
        />),
      });

      return (
        <Marker
          id={data.id}
          key={i}
          position={position}
          icon={icon}
        >
          <Popup autoPan>
            <TableContainer>
              <Table size="small">
                <TableHead />
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                      <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                        {data.station_name}
                      </Box>
                      <Box fontFamily="Kanit" fontSize="12px">
                        {data.name}
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="none" align="center" colSpan={3} style={{ padding: '15px 0px' }}>
                      <Box display="flex" justifyContent="center" alignItems="center">
                        <Box mr={2}>
                          <EwsIcon style={{ fontSize: '1.7rem', fill: statusColor.color.statusColor }} />
                        </Box>
                        <Box>
                          <Box
                            p={1}
                            className={classes.statusText}
                            fontFamily="Kanit"
                            bgcolor={statusColor.color.statusColor}
                            color={statusColor.color.constrastColor}
                            style={{ borderRadius: '2px' }}
                          >
                            {statusColor.color.label}
                          </Box>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.hiddenLine} align="left" style={{ padding: '10px 0px 0px 0px' }}>
                      <Box fontSize="10px">
                        {t('ล่าสุด')}
                        {' '}
                        :
                        {` ${moment(data.pubDate).format('YYYY-MM-DD HH:MM')}`}
                        {' '}
                        น.
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Popup>
          <Tooltip title={`สถานี${data.station_name}`}>
            <span>
              <strong>
                {`สถานี${data.station_name}`}
              </strong>
              <br />
              {`${t(data.name)} `}
              <br />
            </span>
          </Tooltip>
        </Marker>
      );
    }
    return false;
  };

  return (
    <>
      {/* {datas.item.map(eachData)} */}
      {orderBy(datas.item, ['priority'], ['desc']).map(eachData)}
    </>
  );
}

EarlyWarningMap.propTypes = {
  datas: PropTypes.instanceOf(Object).isRequired,
};
